import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressSpinner } from 'primereact/progressspinner';
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faFileAlt, faUsers, faBriefcase, faCalendarAlt, faRotateLeft, faNewspaper, faArrowTrendUp } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

export default class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.state = {
            topBlogs: [],
            topJobs: [],
            dashboardDetails: [],
            route: null,
            isLoading: false,
            dateRange: null,
            totalRecords: 0,
            filterDetails: {
                dateStart: '',
                dateEnd: '',
            }
        };
    }

    componentDidMount() {
        this.getDashboardData();
    }

    getDashboardData = () => {
        let filterDetials = this.state.filterDetails;
        this.setState({ isLoading: true })
        let request = [
            filterDetials.dateStart && Number(moment(filterDetials.dateStart).format('YYYYMMDD')),
            filterDetials.dateEnd && Number(moment(filterDetials.dateEnd).format('YYYYMMDD'))
        ];
        this.adminServices.getDashboardData(request).then((response) => {
            if (response && response.data && response !== null) {
                this.setState({ topBlogs: response.data.mostViewedNewsList, topJobs: response.data.mostAppliedJobList, dashboardDetails: response.data.dashboardData });
            }
            this.setState({ isLoading: false })
        });
    }

    handleChangeDateRange = (value) => {
        let details = this.state.filterDetails

        if (value[0]) {
            details.dateStart = value[0];
            details.dateStart = details.dateStart.setHours(0, 0, 0, 0);
        }

        if (value[1]) {
            details.dateEnd = value[1];
            details.dateEnd = details.dateEnd.setHours(23, 59, 59, 999);
        }
        this.setState({ filterDetails: details, dateRange: value }, () => {
            if (this.state.filterDetails.dateStart && this.state.filterDetails.dateEnd) {
                this.getDashboardData();
            }

        });
    }

    resetFilter = () => {
        let details = this.state.filterDetails
        details.dateStart = '';
        details.dateEnd = '';
        this.setState({ filterDetails: details, dateRange: null }, () => {
            this.getDashboardData()
        });
    }

    render() {
        const statCards = [
            {
                title: 'Inquiries',
                value: this.state.dashboardDetails[0]?.total || 0,
                today: this.state.dashboardDetails[0]?.today || 0,
                week: this.state.dashboardDetails[0]?.week || 0,
                icon: faEnvelope,
                gradient: 'from-blue-500 to-blue-600',
                bgLight: 'bg-blue-50',
                iconBg: 'bg-blue-100',
                iconColor: 'text-blue-600'
            },
            {
                title: 'CV Submitted',
                value: this.state.dashboardDetails[1]?.total || 0,
                today: this.state.dashboardDetails[1]?.today || 0,
                week: this.state.dashboardDetails[1]?.week || 0,
                icon: faUsers,
                gradient: 'from-emerald-500 to-emerald-600',
                bgLight: 'bg-emerald-50',
                iconBg: 'bg-emerald-100',
                iconColor: 'text-emerald-600'
            },
            {
                title: 'Forms Submitted',
                value: this.state.dashboardDetails[2]?.total || 0,
                today: this.state.dashboardDetails[2]?.today || 0,
                week: this.state.dashboardDetails[2]?.week || 0,
                icon: faFileAlt,
                gradient: 'from-violet-500 to-violet-600',
                bgLight: 'bg-violet-50',
                iconBg: 'bg-violet-100',
                iconColor: 'text-violet-600'
            },
            {
                title: 'Newsletter Subscribers',
                value: this.state.dashboardDetails[3]?.total || 0,
                icon: faNewspaper,
                gradient: 'from-amber-500 to-amber-600',
                bgLight: 'bg-amber-50',
                iconBg: 'bg-amber-100',
                iconColor: 'text-amber-600'
            }
        ];

        return (
            <div className="dashboard overflow-y-auto" style={{ height: "calc((100dvh / 0.85) - 60.8px)" }}>
                <div className="dashboard-inner h-full p-[30px]">
                    {/* Header Section */}
                    <div className='flex items-center justify-between mb-6'>
                        <div>
                            <h1 className='text-[26px] m-0 font-bold text-[#1e293b]'>Dashboard</h1>
                            <p className='text-[14px] text-gray-500 mt-1'>Welcome back! Here's what's happening.</p>
                        </div>
                        <div className='flex items-center gap-3'>
                            <div className="flex items-center gap-2 bg-white rounded-lg px-3 py-2 border border-gray-200 shadow-sm">
                                <FontAwesomeIcon icon={faCalendarAlt} className="text-gray-400 w-4 h-4" />
                                <Calendar
                                    value={this.state.dateRange}
                                    onChange={(e) => this.handleChangeDateRange(e.value)}
                                    selectionMode="range"
                                    placeholder="Select date range"
                                    dateFormat="dd M yy"
                                    readOnlyInput
                                    numberOfMonths={2}
                                    maxDate={new Date()}
                                    className="border-0"
                                    inputClassName="border-0 bg-transparent text-sm w-[200px] focus:ring-0"
                                />
                            </div>
                            <button
                                onClick={() => this.resetFilter()}
                                className='flex items-center gap-2 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-all text-sm font-medium'
                            >
                                <FontAwesomeIcon icon={faRotateLeft} className="w-3.5 h-3.5" />
                                Reset
                            </button>
                        </div>
                    </div>

                    {/* Stats Cards */}
                    <div className='grid grid-cols-4 gap-5 mb-6'>
                        {statCards.map((card, index) => (
                            <div key={index} className='bg-white rounded-xl p-5 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 flex flex-col justify-between min-h-[145px]'>
                                <div className='flex items-start justify-between'>
                                    <div>
                                        <p className='text-gray-500 text-sm font-medium mb-1'>{card.title}</p>
                                        <h2 className='text-3xl font-bold text-gray-800'>{card.value}</h2>
                                    </div>
                                    <div className={`w-12 h-12 rounded-xl ${card.iconBg} flex items-center justify-center`}>
                                        <FontAwesomeIcon icon={card.icon} className={`w-5 h-5 ${card.iconColor}`} />
                                    </div>
                                </div>
                                {index < 3 ? (
                                    <div className='mt-4 flex items-center justify-between'>
                                        <div className='flex flex-col'>
                                            <span className='text-[11px] uppercase tracking-wider text-gray-400 font-semibold'>Today</span>
                                            <span className={`text-xl font-bold ${card.iconColor} mt-0.5`}>
                                                {card.today}
                                            </span>
                                        </div>
                                        <div className='flex flex-col items-end'>
                                            <span className='text-[11px] uppercase tracking-wider text-gray-400 font-semibold'>This Week</span>
                                            <span className='text-xl font-bold text-gray-700 mt-0.5'>
                                                {card.week}
                                            </span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className='mt-4 h-[44px]'></div>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Tables Section */}
                    <div className='grid grid-cols-2 gap-6'>
                        {/* Top Blogs */}
                        <div className='bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden'>
                            <div className='px-5 py-4 border-b border-gray-100 flex items-center justify-between'>
                                <div className='flex items-center gap-3'>
                                    <div className='w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center'>
                                        <FontAwesomeIcon icon={faArrowTrendUp} className='w-4 h-4 text-blue-600' />
                                    </div>
                                    <div>
                                        <h2 className='text-[16px] font-semibold text-gray-800 m-0'>Top Blogs</h2>
                                        <p className='text-xs text-gray-500 m-0'>Most viewed articles</p>
                                    </div>
                                </div>
                            </div>
                            <div className='p-4'>
                                <DataTable
                                    value={this.state.topBlogs}
                                    responsiveLayout="scroll"
                                    emptyMessage="No data found"
                                    loading={this.state.isLoading}
                                    loadingIcon={
                                        <div className="flex justify-center items-center w-full py-4">
                                            <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                        </div>
                                    }
                                    className="min-w-full"
                                    rows={5}
                                >
                                    <Column
                                        field="newsblogsid"
                                        header="#"
                                        body={(rowData, options) => (
                                            <span className='text-gray-500 font-medium'>{options.rowIndex + 1}</span>
                                        )}
                                        headerClassName="bg-gray-50 text-gray-600 font-medium text-xs uppercase"
                                        style={{ width: '50px' }}
                                    />
                                    <Column
                                        field="bannerimage"
                                        header="Image"
                                        headerClassName="bg-gray-50 text-gray-600 font-medium text-xs uppercase"
                                        style={{ width: '80px' }}
                                        body={(rowData) => (
                                            <img
                                                src={rowData.bannerimage}
                                                alt="Banner"
                                                className='w-16 h-12 object-cover rounded-lg'
                                            />
                                        )}
                                    />
                                    <Column
                                        field="title"
                                        header="Title"
                                        headerClassName="bg-gray-50 text-gray-600 font-medium text-xs uppercase"
                                        body={(rowData) => (
                                            <span className='text-sm text-gray-700 font-medium line-clamp-2'>{rowData.title}</span>
                                        )}
                                    />
                                    <Column
                                        field="visitcount"
                                        header="Views"
                                        headerClassName="bg-gray-50 text-gray-600 font-medium text-xs uppercase text-center"
                                        style={{ width: '80px' }}
                                        body={(rowData) => (
                                            <span className='inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700'>
                                                {rowData.visitcount}
                                            </span>
                                        )}
                                        bodyStyle={{ textAlign: 'center' }}
                                    />
                                </DataTable>
                            </div>
                        </div>

                        {/* Top Jobs */}
                        <div className='bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden'>
                            <div className='px-5 py-4 border-b border-gray-100 flex items-center justify-between'>
                                <div className='flex items-center gap-3'>
                                    <div className='w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center'>
                                        <FontAwesomeIcon icon={faBriefcase} className='w-4 h-4 text-emerald-600' />
                                    </div>
                                    <div>
                                        <h2 className='text-[16px] font-semibold text-gray-800 m-0'>Top Jobs</h2>
                                        <p className='text-xs text-gray-500 m-0'>Most applied positions</p>
                                    </div>
                                </div>
                            </div>
                            <div className='p-4'>
                                <DataTable
                                    value={this.state.topJobs}
                                    responsiveLayout="scroll"
                                    emptyMessage="No data found"
                                    loading={this.state.isLoading}
                                    loadingIcon={
                                        <div className="flex justify-center items-center w-full py-4">
                                            <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                        </div>
                                    }
                                    className="min-w-full"
                                    rows={5}
                                >
                                    <Column
                                        field="jobid"
                                        header="#"
                                        body={(rowData, options) => (
                                            <span className='text-gray-500 font-medium'>{options.rowIndex + 1}</span>
                                        )}
                                        headerClassName="bg-gray-50 text-gray-600 font-medium text-xs uppercase"
                                        style={{ width: '50px' }}
                                    />
                                    <Column
                                        field="jobname"
                                        header="Job Position"
                                        headerClassName="bg-gray-50 text-gray-600 font-medium text-xs uppercase"
                                        body={(rowData) => (
                                            <div className='flex items-center gap-3'>
                                                <div className='w-9 h-9 rounded-lg bg-gradient-to-br from-emerald-400 to-emerald-500 flex items-center justify-center text-white font-semibold text-sm'>
                                                    {rowData.jobname?.charAt(0)?.toUpperCase()}
                                                </div>
                                                <span className='text-sm text-gray-700 font-medium'>{rowData.jobname}</span>
                                            </div>
                                        )}
                                    />
                                    <Column
                                        field="total_applications"
                                        header="Applicants"
                                        headerClassName="bg-gray-50 text-gray-600 font-medium text-xs uppercase text-center"
                                        style={{ width: '100px' }}
                                        body={(rowData) => (
                                            <span className='inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-700'>
                                                {rowData.total_applications}
                                            </span>
                                        )}
                                        bodyStyle={{ textAlign: 'center' }}
                                    />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
